import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Drawer, Notification } from 'components/';
import * as Queries from 'api/graphql/queries';
import * as Mutations from 'api/graphql/mutations';
import { AdminShippingMethodsList, AdminShippingMethodsList_adminShippingMethods, OrderDirection } from '@api/graphql/types';
import { RowInfo, SortingRule } from 'react-table';
import Paths from '../paths';
import { BooleanCell, WeightCell, OpenInNewCell } from '@components/Table/Cell';
import GraphQLClient from '@api/graphql/GraphQLClient';
import { shouldPriceAppear } from '@root/utils/ShippingMethod';
import ReduxTable from '@components/ReduxTable';

interface StateType {
    adminShippingMethods: Array<(AdminShippingMethodsList_adminShippingMethods | null)>;
}

type Props = InjectedIntlProps & RouteComponentProps;

export const ShippingMethodListDefaultOptions = {
    sortBy: {
        field: 'sort',
        direction: OrderDirection.ASC,
    },
    count: 10,
    page: 0,
    filters: {
    },
};

const listName = 'shippingMethodList';

class ShippingMethodList extends React.Component<Props, StateType> {
    private defaultSorted: SortingRule[] = [{id: 'sort'}];

    private SortCell = (row : any) => {
        if (!this.state || !this.state.adminShippingMethods) {
            return <span>{row.value}</span>;
        }

        const index = this.state.adminShippingMethods.indexOf(row.original);
        const isFirst = index === 0;
        const isLast = index === this.state.adminShippingMethods.length - 1;

        return (
            <div style={{display: 'flex', flexFlow: 'row wrap'}}>
                <div style={{flex: '0 0 50%'}}>
                    {!isFirst && <a onClick={this.move(row.original, 'before', this.state.adminShippingMethods![(index - 1)]!.id)}><i className="fa fa-chevron-up" /></a>}
                </div>
                <div style={{flex: '0 0 50%'}}>
                    {!isLast && <a onClick={this.move(row.original, 'after', this.state.adminShippingMethods![(index + 1)]!.id)}><i className="fa fa-chevron-down" /></a>}
                </div>
            </div>
        );
    }

    private PriceCell = (row: any) => {
        return (shouldPriceAppear(row.original.code)) ? <span>{row.value}</span> : <span>{null}</span>;
    }

    private move = (item: AdminShippingMethodsList_adminShippingMethods, direction: 'before' | 'after', id: string) => (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();

        GraphQLClient.mutate({
            mutation: Mutations.updateShippingMethod,
            variables: {...item, [direction]: id},
        }).then(() => {
            this.fetchData();
            Notification.success(this.props.intl.formatMessage({ id: 'notification.succeed' }));
        }).catch((error: any) => {
            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        });
    }

    private OpenCell = OpenInNewCell((rowInfo: any) => {
        return `${Paths.shippingMethod}/${rowInfo.original.id}`;
    });

    private tableColumns = [
        {Header: '', sortable: false, Cell: this.OpenCell, width: 30},
        this.getDefaultColumnByName('id'),
        this.getDefaultColumnByName('name'),
        this.getDefaultColumnByName('is_active', {Cell: BooleanCell}),
        this.getDefaultColumnByName('sort', {Cell: this.SortCell}),
        this.getDefaultColumnByName('price', {Cell: this.PriceCell}),
        this.getDefaultColumnByName('max_weight', {Cell: WeightCell}),
        this.getDefaultColumnByName('description'),
        this.getDefaultColumnByName('short_description'),
        this.getDefaultColumnByName('delivery_time'),
    ];

    public componentDidMount() {
        this.fetchData();
    }

    public fetchData() {
        GraphQLClient.query<AdminShippingMethodsList>({
            query: Queries.adminShippingMethods,
        }).then((response) => {
            if (response.data) {
                this.setState({adminShippingMethods: response.data.adminShippingMethods.sort((a, b) => {
                    return a!.sort - b!.sort;
                })});
            }
        });
    }

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: false,
            ...options,
        };
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.shippingMethod.${id}` });
    }

    public render() {
        return (
            <Drawer>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                {this.state && this.state.adminShippingMethods && (
                                    <ReduxTable
                                        listName={listName}
                                        defaultOptions={ShippingMethodListDefaultOptions}
                                        onClick={(rowInfo: RowInfo) => {
                                            this.props.history.push(`${Paths.shippingMethod}/${rowInfo.original.id}`);
                                        }}
                                        data={this.state.adminShippingMethods}
                                        columns={this.tableColumns}
                                        defaultPageSize={10}
                                        defaultSorted={this.defaultSorted}
                                        sortable={false}
                                        filterable={false}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

export default compose(
    withRouter,
    injectIntl,
)(ShippingMethodList);



// WEBPACK FOOTER //
// ./src/modules/ShippingMethod/pages/ShippingMethodList.tsx